module.exports = __webpack_public_path__ + "img/3ea43d3.jpg";